import React from 'react';
import { node } from 'prop-types';
import classnames from 'classnames';
import { ListItem } from '../list';

const MenuItem = ({ children, className, disabled, onClick, ...props }) => (
  <ListItem
    role="menuitem"
    tabIndex="0"
    className={classnames(className, { 'mdc-list-item--disabled': disabled })}
    onClick={(e) => {
      if (!disabled) {
        onClick(e);
      } else {
        e.stopPropagation();
      }
    }}
    {...props}
  >
    {children}
  </ListItem>
);

MenuItem.propTypes = {
  children: node.isRequired,
};

export default MenuItem;
